<div [formGroup]="form" *ngIf="form" class="product-form">
    <div class="image-section" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px" fxLayoutGap.lt-sm="20px"
        fxLayoutAlign.lt-sm="start center">
        <app-square-image-upload *ngIf="showImageInput"
            [productId]="product?.id"
            [imageUrl]="product?.image"
            [productName]="product?.title"
            [editable]="true"
            [excludable]="true"
            [resetTrigger]="itemCreated"
            (imageChanged)="onImageChanged($event)">
        </app-square-image-upload>

        <div class="fields" fxFlex fxLayout="column">
            <!-- Nome (contador abaixo do campo, à direita, com espaço reservado) -->
            <mat-form-field class="min-width has-subscript" appearance="outline">
                <mat-label>Nome</mat-label>
                <input type="text" #nomeInput placeholder="Nome do produto ou serviço" matInput
                    formControlName="title" required maxlength="400">
                <mat-hint align="end">{{ (form.get('title')?.value || '')?.length || 0 }}/400</mat-hint>
                <mat-error *ngIf="form.get('title')?.hasError('maxlength')">
                    O nome do produto não pode ter mais de 400 caracteres
                </mat-error>
                <mat-error *ngIf="form.get('title')?.hasError('required')">
                    Informe o nome do produto
                </mat-error>
            </mat-form-field>

            <!-- Código e Valor -->
            <div class="field-row" fxLayout="row" fxLayout.xs="column" fxLayoutGap="12px" fxLayoutGap.xs="0">
                <mat-form-field class="min-width" appearance="outline" fxFlex>
                    <mat-label>Código</mat-label>
                    <input type="text" placeholder="Código do produto" matInput formControlName="code">
                </mat-form-field>

                <mat-form-field class="min-width" appearance="outline" fxFlex>
                    <mat-label>Valor de venda</mat-label>
                    <input [options]="brlMask" inputmode="numeric" autocomplete="off" currencyMask
                        formControlName="valor" required matInput>
                </mat-form-field>
            </div>

            <!-- Valor de compra e estoque mínimo -->
            <div *hasStockFeature class="field-row" fxLayout="row" fxLayout.xs="column" fxLayoutGap="12px" fxLayoutGap.xs="0">
                <mat-form-field class="min-width" appearance="outline" fxFlex>
                    <mat-label>Valor de compra</mat-label>
                    <input [options]="brlMask" inputmode="numeric" autocomplete="off" currencyMask
                        formControlName="valor_compra" matInput>
                </mat-form-field>

                <mat-form-field class="min-width" appearance="outline" fxFlex>
                    <mat-label>Estoque mínimo</mat-label>
                    <input type="number" min="0" inputmode="decimal" autocomplete="off"
                        formControlName="estoque_minimo" matInput>
                </mat-form-field>
            </div>

            <!-- Categoria e Unidade -->
            <div class="field-row" fxLayout="row" fxLayout.xs="column" fxLayoutGap="12px" fxLayoutGap.xs="0">
                <mat-form-field class="min-width" appearance="outline" fxFlex>
                    <mat-label>Categoria</mat-label>
                    <mat-icon matSuffix class="secondary-text">category</mat-icon>
                    <mat-select #productCategorySelect formControlName="product_category_id"
                        placeholder="Categoria" panelClass="panelResponsive">
                        <mat-option>
                            <ngx-mat-select-search [formControl]="bankFilterCtrl"
                                [placeholderLabel]="'Buscar...'"
                                [noEntriesFoundLabel]="'Nenhuma categoria encontrada'"
                                style="height: 80px;"
                                name="search"
                                [disableScrollToActiveOnOptionsChanged]="true">
                                <div class="mat-select-search-custom-header-content">
                                    <app-card-drop-down-product-category-create
                                        [iconOnly]="true" class="btn-add-client-inline"
                                        fxLayoutAlign="center center" fxFlex="100"
                                        (onCreated)="productCategoryCreated($event, productCategorySelect)">
                                        <mat-icon>category</mat-icon>
                                    </app-card-drop-down-product-category-create>
                                </div>
                            </ngx-mat-select-search>
                        </mat-option>

                        <mat-option *ngFor="let productCategory of productCategoriesFiltered | async"
                            [value]="productCategory.id">
                            <span>{{ productCategory.title }}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="min-width" appearance="outline" fxFlex>
                    <mat-label>Unidade</mat-label>
                    <mat-icon matSuffix class="secondary-text">perm_data_setting</mat-icon>
                    <mat-select #unitSelect formControlName="unit_id" placeholder="Unidade" required
                        panelClass="panelResponsive">
                        <mat-option>
                            <ngx-mat-select-search [formControl]="unitFilterCtrl"
                                [placeholderLabel]="'Buscar...'"
                                [noEntriesFoundLabel]="'Nenhuma unidade encontrada'"
                                style="height: 80px;"
                                name="search"
                                [disableScrollToActiveOnOptionsChanged]="true">
                                <div class="mat-select-search-custom-header-content">
                                    <app-card-drop-down-unit-create
                                        [iconOnly]="true" class="btn-add-client-inline"
                                        fxLayoutAlign="center center" fxFlex="100"
                                        (onCreated)="unitCreated($event, unitSelect)">
                                        <mat-icon>perm_data_setting</mat-icon>
                                    </app-card-drop-down-unit-create>
                                </div>
                            </ngx-mat-select-search>
                        </mat-option>

                        <mat-option *ngFor="let unit of unitsFiltered | async" [value]="unit.id">
                            <span *ngIf="unit?.abbr">{{ unit.name }} ({{ unit.abbr }})</span>
                            <span *ngIf="!unit?.abbr">{{ unit.name }}</span>
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('unit_id')?.hasError('required')">Escolha a unidade</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>

    <!-- Descrição: largura toda -->
    <mat-form-field class="min-width has-subscript" appearance="outline">
        <mat-label>Descrição</mat-label>
        <textarea name="description" formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="10" maxlength="1000" matInput></textarea>
        <mat-hint align="end">{{ (form.get('description')?.value || '')?.length || 0 }}/1000</mat-hint>
        <mat-error *ngIf="form.get('description')?.hasError('maxlength')">
            A descrição não pode ter mais de 1000 caracteres
        </mat-error>
    </mat-form-field>

    <div class="switch-list">
        <div *hasStockFeature class="switch-row">
            <span>Controle de estoque</span>
            <orca-switch [isActive]="product?.stockControlEnabled !== false" ariaLabel="Controle de estoque"
                (toggle)="toggleStockControl($event)"></orca-switch>
        </div>
        <div *ngIf="showStatusInput" class="switch-row">
            <span>Status do produto</span>
            <orca-switch [isActive]="product?.status == 1" ariaLabel="Status do produto"
                (toggle)="toggleStatus(product, $event)"></orca-switch>
        </div>
    </div>

    <!-- Fora de diálogo (detalhe do produto) -->
    <div *ngIf="!inDialog" class="form-actions">
        <button *ngIf="!product?.id" type="button" class="oa-btn oa-btn--primary"
            [disabled]="loading || !form.dirty || !form.valid" [attr.aria-busy]="loading || null" (click)="store()">
            <span>Criar produto</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
        <button *ngIf="product?.id" type="button" class="oa-btn oa-btn--primary"
            [disabled]="loading || !form.dirty || !form.valid" [attr.aria-busy]="loading || null" (click)="update()">
            <span>Salvar alterações</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
    </div>
</div>
